<div
  class="phx-month-picker-month-cell phx-web-type-body-medium"
  [tabindex]="i === 0 ? '0' : '-1'"
  *ngFor="let month of months; let i = index"
  (click)="selectMonth(month)"
  (mouseenter)="hoverMonth(month)"
  (mouseleave)="leaveMonth()"
  (focus)="focusedMonthIndex = i"
  (keydown)="handleKeyboardEvent($event)"
  (keydown.enter)="selectMonth(month)"
  [class.phx-web-type-body-medium-emphasis]="isTodayMonth(month)"
  [class.phx-month-picker-selected]="phxShowSelection && (isSelectedMonth(month) || isRangeSame(month))"
  [class.phx-month-picker-range]="phxShowSelection && isInSelectedRange(month)"
  [class.phx-month-picker-hover-range]="isInHoveredRange(month)"
  [class.phx-month-picker-range-start]="isRangeStart(month) && !hoverDirection && !isRangeSame(month)"
  [class.phx-month-picker-range-end]="isRangeEnd(month) && !hoverDirection && !isRangeSame(month)"
  [class.phx-month-picker-hover-left]="hoverDirection === 'left'"
  [class.phx-month-picker-hover-right]="hoverDirection === 'right'"
  [attr.aria-selected]="i === focusedMonthIndex"
  role="option"
>
  {{ monthNames[i] }}
</div>
